
export class CsBankModel {
  _id: string;
  balance: number;
  reserved: number;
  spent: number;
}









